(() => {
  const form = document.getElementById('GazdaSerbiaMarket');
  if (!form) return;
  const key = 'gazda-serbia-market-v1';
  const now = Date.now();
  try {
    const attemptedAt = Number(sessionStorage.getItem(key) || 0);
    if (now - attemptedAt < 300000) return;
    sessionStorage.setItem(key, String(now));
  } catch {
    return;
  }
  const destination = form.querySelector('[name="return_to"]');
  if (destination) destination.value = window.location.pathname + window.location.search;
  form.requestSubmit();
})();
